import { render } from "@/components/pages/dtcTable/DtcTable.html?vue&type=template&id=c2d4e38a&external"
import script from "@/components/pages/dtcTable/DtcTable.js?vue&type=script&lang=js&external"
export * from "@/components/pages/dtcTable/DtcTable.js?vue&type=script&lang=js&external"

import "@/components/pages/dtcTable/DtcTable.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__